import React from 'react';
import { Form, Table } from 'react-bootstrap';
import SeasonRatePickerItem from './SeasonRatePickerItem';
import { SeasonRateDetails } from '../seasonRatesSlice';

interface SeasonRatePickerListProps {
  seasonRateItems: SeasonRateDetails[];
  onCheckboxChange: (id: string, isChecked: boolean) => void;
  onToggleAll: (isChecked: boolean) => void;
  isAllSelected: boolean;
  selectedIds: string[];
}

const SeasonRatePickerList: React.FC<SeasonRatePickerListProps> = ({
  seasonRateItems,
  onCheckboxChange,
  onToggleAll,
  isAllSelected,
  selectedIds,
}) => {
  const handleToggleAll = (event: React.ChangeEvent<HTMLInputElement>) => {
    onToggleAll(event.target.checked);
  };

  const selectAllLabel = isAllSelected
    ? 'Poista kaikki valinnat'
    : 'Valitse kaikki';

  return (
    <div
      style={{ height: '400px', overflowY: 'auto' }}
      className="border-start border-end mb-24"
    >
      <div className="border-bottom bg-white" style={{ padding: '8px 12px' }}>
        <Form.Check
          type="checkbox"
          name="seasonRatePickerSelectAll"
          label={selectAllLabel}
          checked={isAllSelected}
          onChange={handleToggleAll}
        />
      </div>
      <Table className="mb-0 rounded-0">
        {seasonRateItems.map(item => (
          <SeasonRatePickerItem
            key={item.id}
            seasonRateItem={item}
            onCheckboxChange={onCheckboxChange}
            isChecked={selectedIds.includes(item.id)}
          />
        ))}
      </Table>
    </div>
  );
};

export default SeasonRatePickerList;
